import { c as _c } from "react/compiler-runtime";
import { PreservingNavigate } from "@components/common/preserve-navigation/preserving-navigate";
import { useMediaQueryList } from "@hooks/use-media-query";
import { AccountSettingsLayout } from "@pages/account-settings/account-settings-layout/account-settings-layout";
import { canGuestOpenAccountSettingsTab } from "@pages/account-settings/account-settings-utils";
import { UserProvider } from "@pages/account-settings/user-provider";
import { AccountSettingsTabs } from "@router/route-params";
import { generateAccountSettingsRoute, useAppParams } from "@router/router-helper";
import { useAppSelector } from "@store/store-helper";
import { fetchingUserFlagsSelector, loggedInUserSelector } from "@store/user/user-selector";

/** Content for the account settings page */
export function AccountSettingsPage() {
  const $ = _c(5);
  const {
    accountSettingsTab
  } = useAppParams();
  const {
    isScreenSmOrSmaller
  } = useMediaQueryList();
  const {
    loggedInUserFetchingStatus
  } = useAppSelector(fetchingUserFlagsSelector);
  const loggedInUser = useAppSelector(loggedInUserSelector);
  if (loggedInUserFetchingStatus === "uninitialized" || loggedInUserFetchingStatus === "pending") {
    return;
  }
  const isGuestUser = !loggedInUser;
  if (isGuestUser && !canGuestOpenAccountSettingsTab(accountSettingsTab)) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <PreservingNavigate to={generateAccountSettingsRoute(AccountSettingsTabs.preferences)} />;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  if (loggedInUser && accountSettingsTab === undefined && !isScreenSmOrSmaller) {
    let t0;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <PreservingNavigate to={generateAccountSettingsRoute(AccountSettingsTabs.security)} />;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    return t0;
  }
  const t0 = loggedInUser ?? undefined;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <AccountSettingsLayout />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t0) {
    t2 = <UserProvider user={t0}>{t1}</UserProvider>;
    $[3] = t0;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}